package ca.derekellis.reroute.db.web

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import ca.derekellis.reroute.db.Metadata
import ca.derekellis.reroute.db.MetadataQueries
import ca.derekellis.reroute.db.RerouteDatabase
import ca.derekellis.reroute.db.StopSearchQueries
import ca.derekellis.reroute.db.StopsQueries
import kotlin.Int
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<RerouteDatabase>.schema: SqlSchema
  get() = RerouteDatabaseImpl.Schema

internal fun KClass<RerouteDatabase>.newInstance(driver: SqlDriver,
    MetadataAdapter: Metadata.Adapter): RerouteDatabase = RerouteDatabaseImpl(driver,
    MetadataAdapter)

private class RerouteDatabaseImpl(
  driver: SqlDriver,
  MetadataAdapter: Metadata.Adapter,
) : SuspendingTransacterImpl(driver), RerouteDatabase {
  public override val metadataQueries: MetadataQueries = MetadataQueries(driver, MetadataAdapter)

  public override val stopSearchQueries: StopSearchQueries = StopSearchQueries(driver)

  public override val stopsQueries: StopsQueries = StopsQueries(driver)

  public object Schema : SqlSchema {
    public override val version: Int
      get() = 1

    public override fun create(driver: SqlDriver): QueryResult<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE Metadata (
          |    updated TEXT NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE routes (
          |    id TEXT NOT NULL PRIMARY KEY,
          |    short_name TEXT NOT NULL,
          |    long_name TEXT,
          |    desc TEXT,
          |    type INTEGER NOT NULL,
          |    url TEXT,
          |    color TEXT,
          |    text_color TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE stops (
          |    id TEXT NOT NULL PRIMARY KEY,
          |    code TEXT NOT NULL,
          |    name TEXT NOT NULL,
          |    desc TEXT,
          |    lat REAL NOT NULL,
          |    lon REAL NOT NULL,
          |    zone_id INTEGER,
          |    url TEXT,
          |    location_type INTEGER NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TRIGGER update_stop_search AFTER INSERT ON stops
          |BEGIN
          |INSERT INTO stop_search(id, code, name)
          |VALUES(new.id, new.code, new.name);
          |END
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE VIRTUAL TABLE stop_search USING fts3 (
          |    id TEXT NOT NULL,
          |    code TEXT NOT NULL,
          |    name TEXT NOT NULL,
          |    tokenize=unicode61
          |)
          """.trimMargin(), 0).await()
    }

    public override fun migrate(
      driver: SqlDriver,
      oldVersion: Int,
      newVersion: Int,
    ): QueryResult<Unit> = QueryResult.AsyncValue {
    }
  }
}
